module.exports = __webpack_public_path__ + "img/kh.695ec7a.svg";